import { CasinoCollectionModelExt } from './CasinoCollectionModelExt';
import { CasinoGameModelExt } from './CasinoGameModelExt';
import { CasinoSearchExt } from './CasinoSearchExt';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { CollectionType } from 'src/domains/casino/types/types';
import { GameClient } from './http-clients/adapter';
import { Common } from 'src/domains/common/Common';
import { RedirectState } from 'src/domains/casino/state/AppCasino/Redirect.state';
import { GameModalState } from 'src/domains/casino/state/AppCasino/game-modal/GameModal.state';

export class GameStoreExt {
    public gameClient: GameClient;
    private collectionMap: AutoMap<CollectionType, CasinoCollectionModelExt>;

    public constructor(
        private search: CasinoSearchExt,
        private readonly common: Common,
        private readonly redirectState: RedirectState,
        private readonly gameModalState: GameModalState
    ) {
        this.gameClient = new GameClient(this.common);
        this.collectionMap = new AutoMap((collection: CollectionType) => {
            return CasinoCollectionModelExt.newFromParams(
                this.search,
                collection,
                this.gameClient,
                this.redirectState,
                this.gameModalState
            );
        });
    }

    public getCollection(id: CollectionType): CasinoCollectionModelExt {
        return this.collectionMap.get(id);
    }

    public get allCollections(): Array<CasinoCollectionModelExt> {
        const allCollections: Array<CasinoCollectionModelExt> = [];
        for (const collection of this.common.features.casinoPublishedCollections) {
            if (collection !== 'bingo') {
                const data = this.getCollection(collection);
                allCollections.push(data);
            }
        }
        return allCollections;
    }

    public getGameModel(id: number): CasinoGameModelExt | null {
        for (const collection of this.allCollections) {
            const model = collection.getGameModel(id);

            if (model.data !== null) {
                return model;
            }
        }

        return null;
    }

    /**
     * @deprecated: On the Website we should use CMS id only (casino-store game id in the future).
     * bonus-engine need stop using launchGameId and start return CMS ids.
     */
    public getGameModelByLaunchGameId(id: string | number): CasinoGameModelExt | null {
        for (const collection of this.allCollections) {
            for (const game of collection.games) {
                if (game.launchGameId.toString() === id.toString()) {
                    return game;
                }
            }
        }

        return null;
    }

    public gameExists(gameId: number): boolean {
        const game = this.getGameModel(gameId);

        if (game === null) {
            return false;
        }

        return game.data === null ? false : true;
    }
}
